import type { PropsWithChildren } from "react";

export function FormContainer({ children }: PropsWithChildren) {
  return <div className="mt-8">{children}</div>;
}
export function FormContainerBody({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col gap-6 bg-neutral-50 px-2 py-5">
      {children}
    </div>
  );
}
export function FormContainerFooter({ children }: PropsWithChildren) {
  return (
    <div className="flex justify-end gap-2 bg-gray-50 py-3 text-right">
      {children}
    </div>
  );
}

export function FormSection({ children }: PropsWithChildren) {
  return (
    <section className="rounded-lg border bg-white p-6">{children}</section>
  );
}
